import { deleteApi, patchApi } from '../../../utils/api'

// List/detail live under the v3 archive resource keyed by `scopeId`; note and
// delete hit the legacy per-message endpoint keyed by `uuid`.

// Regular v3 listing endpoint: `filters`/`ordering`/`page`/`size` in the body.
export function getEntityEmailArchiveListApi(scopeId) {
  return `idwell-api/api/v3/email/email-archives/profile/${scopeId}/messages/filter/`
}

export function getEntityEmailArchiveMessageApi({ scopeId, uuid }) {
  return `idwell-api/api/v3/email/email-archives/profile/${scopeId}/messages/${uuid}/`
}

export function deleteEntityEmailArchiveCopy({ uuid }) {
  return deleteApi({
    endpoint: `api/email-archive/email-message/${uuid}/`,
  })
}

export function updateEntityEmailArchiveNote({ notes, uuid }) {
  return patchApi({
    data: { notes },
    endpoint: `api/email-archive/email-message/${uuid}/`,
  })
}
